/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { createRoute } from '@gh/builder-shared';
import { EmailRecipientListComponent } from './components/email-recipient-list/email-recipient-list.component';
import { EmailRecipientListBusinessService } from './components/resources/email-recipient-list-business.service';

const routes = [
  createRoute({
    component: EmailRecipientListComponent,
    path: '',
    pathMatch: 'full',
    leave: true,
    init: EmailRecipientListBusinessService,
    auth: {
      permission: [
        'Setup.EmailRecipients.EDIT_VIEW',
      ],
    },
  }),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BuilderSetupEmailRecipientsRoutingModule {
}
